import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MousePointerClick, Eye, Stethoscope, Quote, BookOpen, Image, Video, Home } from "lucide-react";
import { api } from "@/lib/api";
import { AdminShell } from "@/components/admin/AdminShell";

function Stat({ icon: Icon, label, value }) {
  return (
    <div className="bg-ivory border border-espresso/10 rounded-md p-6">
      <Icon size={20} className="text-brass mb-4" strokeWidth={1.5} />
      <div className="font-serif text-4xl text-espresso">{value ?? "—"}</div>
      <div className="text-xs uppercase tracking-[0.14em] text-taupe mt-1">{label}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/analytics/summary").then((r) => setS(r.data)).catch(() => {});
  }, []);

  return (
    <AdminShell title="Dashboard" subtitle="Your practice at a glance">
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-10">
        <Stat icon={Eye} label="Page Views" value={s?.pageviews} />
        <Stat icon={MousePointerClick} label="Booking Clicks" value={s?.booking_clicks} />
        <Stat icon={Stethoscope} label="Treatments" value={s?.services} />
        <Stat icon={Quote} label="Patient Stories" value={s?.testimonials} />
        <Stat icon={BookOpen} label="Articles" value={s?.articles} />
        <Stat icon={Image} label="Media Files" value={s?.media} />
      </div>

      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-ivory border border-espresso/10 rounded-md p-7">
          <h2 className="font-serif text-2xl text-espresso mb-5">Booking clicks by location</h2>
          {(s?.booking_by_label || []).length === 0 && <p className="text-sm text-taupe">No booking clicks yet.</p>}
          <div className="space-y-3">
            {(s?.booking_by_label || []).map((b) => (
              <div key={b._id} className="flex justify-between text-sm border-b border-espresso/5 pb-2">
                <span className="text-espressosoft">{b._id || "unknown"}</span>
                <span className="font-medium">{b.count}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-espresso text-ivory rounded-md p-7">
          <h2 className="font-serif text-2xl mb-2">Replace your homepage video in ~60 seconds</h2>
          <p className="text-ivory/60 text-sm mb-6">Homepage → Hero → Upload → Preview → Publish.</p>
          <div className="flex flex-wrap gap-3">
            <Link to="/admin/home" className="inline-flex items-center gap-2 bg-brass text-espresso px-6 py-3 rounded-full text-xs uppercase tracking-[0.14em] hover:bg-brassdark hover:text-ivory transition-all" data-testid="dashboard-edit-home">
              <Video size={15} /> Edit Homepage Hero
            </Link>
            <Link to="/admin/settings" className="inline-flex items-center gap-2 border border-ivory/30 px-6 py-3 rounded-full text-xs uppercase tracking-[0.14em] hover:bg-ivory/10 transition-all" data-testid="dashboard-edit-settings">
              <Home size={15} /> Contact & Hours
            </Link>
          </div>
        </div>
      </div>
    </AdminShell>
  );
}
